import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(({ spacing }) => ({
  informationWrapper: {
    padding: spacing(1, 3),
    textAlign: 'center',
  },
  informationParagraph: {
    padding: spacing(0, 2),
    paddingBottom: spacing(1),
  },
}));

export default styles;
